"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUsersHandler = void 0;
var msw_1 = require("msw");
var mockData_1 = require("@test/users/mockData");
exports.getUsersHandler = [
    msw_1.http.get("http://localhost:4545/api/v1/users", function () {
        return msw_1.HttpResponse.json(mockData_1.mockUsers);
    }),
];
